// extracted by mini-css-extract-plugin
export default {"link":"Q1eWI2P0XpBhf54FGnPS"};